import React from 'react';

interface ConsentInputProps {
  enabled: unknown;
  consentKey: unknown;
  consentDate?: string;
}

const ConsentInput = ({ enabled, consentKey, consentDate = '' }: ConsentInputProps) => {
  if (!consentKey || !enabled || !consentDate) {
    return null;
  }
  return <input type="hidden" value={consentDate} name={consentKey} />;
};

export default ConsentInput;
